const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import render from "../../utilities/render";
import {isPresent, formateDateUtil, shallAllowClick} from "../../utilities/general";
import { statusPillRender, buildExport, prepareDataToSendController, isEdit, doAjax, pushFilterSessionCacheState, retriveCriteriaObjectByOperation, isNew, isDeleteView, isOnlyLookupDataUpdate } from "../../utilities/filtersutil";
import { handleCustomDropdownEvents } from "../../utilities/customBootstrapDropdowns";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT } from "../../constants";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";
import {actionOptions} from "./filter/actionOptions.js";
import {searchDropdown} from "./filter/searchDropdown.js";

const modalHtml = require("../../sharedHtml/modal.html");
const _ = require("underscore");
const detailLinkHTML = require('../../utilities/filtersutil/html/detailLinkHTML.html');
const targetSelector = "#order-type-lookup";
let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');
let actionList = actionOptions;


run(targetSelector,(mainEl) => {
		const viewOrderTypeDetailUrl = mainEl.data("order-type-detail-url");
		const orderTypeLookupTable = mainEl.find("#order-type-lookup-wrapper");
    let targetObject = "";
    let selectedRows = "";
    const editPermission = true;
    const shouldCheckCache  = mainEl.data("should-check-cache");
   	const generateExportUrl = mainEl.data("export-url");
    const savedViews  = mainEl.data("saved-views");
    const dataTableComponentData =  mainEl.data("order-type-lookup-json");
    const filterOrderTypesUrl = mainEl.data("order-types-filter-url");
    const saveViewURL  =  mainEl.data("save-view-url");
    let exportModal = new buildExport();
    const deleteViewURL  =  mainEl.data("delete-view-url");
   	const extraDetailForCacheFromServer  =  mainEl.data("extra-detail-for-cache-from-server");
    const criteriaObjectFromServer  =  mainEl.data("filter-criteria-from-server");
    const updateOrderTypeStatusUrl = mainEl.data("updateOrderTypeStatusUrl");
    const portletNamespace =  mainEl.data("portlet-namespace");
    const bulkActivateOrderTypesUrl = mainEl.data("bulk-activate-order-types-url");
    const bulkDeactivateOrderTypesUrl = mainEl.data("bulk-deactivate-order-types-url");
    const defaultOrderTypesList = mainEl.data("default-order-types-list");
    const orderTypeEditURL = mainEl.data("edit-order-type-url");

    if(shouldCheckCache){
	    targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer,"like");
  	}

    function createDetailLink(data, type, row) {
		let detailPageHTML = render(
			detailLinkHTML, {
			  renderURL :  viewOrderTypeDetailUrl,
			  portletNamespace :  portletNamespace,
			  id :   row.customOrderTypeId,
			  idName : "ortId",
			  displayVal:row.name
			}
		);
		return detailPageHTML;
    }

    var orderTypeLookup = new LookupTable({
    	target : orderTypeLookupTable,
    	minWidthClass: "q-min-width-sm-til-md",
    	mobileColumns: [
    		{
    			data: "name",
    			title:"Order Type Name",
    			render: createDetailLink
    		},
    		{
    			data:"code",
    			title:"Order Code",
    			orderable:false,
    		},
    		{
    			data:"createdDate",
    			title:"Created On",
    			orderable:false,
    		},
    		{
    			data:"status",
    			title:"Status",
    			render: statusPillRender,
    			orderable:false,
    		}
    	],

    	tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: (targetObject != "" ? targetObject.value[0] : "")

	    },
	    tableSearchDropdown: {
	  		selected: (targetObject == "" ? "" : targetObject.key),
      		columns:searchDropdown
    	},
	    savedViews: savedViews,
   		bulkSelect: true,

   		dataTable: {
   			data: dataTableComponentData.content,
   			columnDefs: [{ 
	        		className: "custom-class", targets: [ 1 ] 
	        }],

	    	order: [
	        	[4, 'desc'],
	    	],

	    	columns: [
	    		{
	    			data: "customOrderTypeId",
	          		render : renderActionWrap,
	          		orderable:false,
	          		class: 'dtc-action-column'
	    		},
	    		{
	    			data: "name",
    				title:"Order Type Name",
    				render: createDetailLink,
    				class: 'dtc-min-width-md'
	    		},
	    		{
	    			data: "code",
    				title:"Order Type Code",
    				class: 'dtc-min-width-sm'
	    		},
	    		{
	    			data: "createdDate",
    				title:"Created On",
    				render: formateDateUtil,
    				class: 'dtc-min-width-sm'
	    		},
	    		{
	    			data: "status",
	    			title: "Status",
	    			render: statusPillRender,
	          		class: 'dtc-min-width-sm'
	    		},
	    		{
	    			data: "fulfillmentCenter",
    				title:"Fulfillment Center",
    				class: 'dtc-min-width-md'
	    		},
	    		{
	    			data: "billing.billingMethod",
    				title:"Billing Method",
    				class: 'dtc-min-width-sm'
	    		}
	    		
	    	]
   		},
   		paginationData:dataTableComponentData.page,
    		filterModal: {
      		// REQUIRED: Sets title of modal
      		title: "Filter Order Types",
      		// REQUIRED: Sets unique part of subtitle string.
      		tableType: "orderTypes"
    },
    	onBulkSelectChange: function() {
		    selectedRows = orderTypeLookup.getBulkSelectedData();
    	    $("th.dtc-action-column").html(renderActionHeaderWrap());
		    if (selectedRows.length >= 2) {
				$(".action-header-btn .base-btn").removeClass('disabled');
			}else{
			    $(".action-header-btn .base-btn").addClass('disabled');
			};
		},
		onFetch: function() {
	      let currentData = orderTypeLookup.generateData();
	      orderTypeLookup.showLoadingOverlay();
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
       	  if(isOnlyLookupDataUpdate(currentData)){
       	  	setTimeout(() => {
				doAjax({url: filterOrderTypesUrl, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData)});
	      	},SUCCESS_MODAL_TIMEOUT);
		   }else if(isNew(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }else if(isEdit(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }else if(isDeleteView(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }
		}
    });

    orderTypeLookup.init();
     var table = $("#order-type-lookup-wrapper .data-table-component").DataTable();

   /* function renderActionWrap(data, type, row, meta) {
	    let newRender;
	    let statusTarget = actionList["actions"];
	    newRender = render(
	      actionCellDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row),
	        index: meta.row
	      }
	    );
	    return newRender;
		};*/
		

		function renderActionWrap(data, type, row, meta) {
			if (row.retailerId == "0" && row.code !== "B2B" && row.code !== "B2C") {
				data = "actionActiveDeactive";
			} else {
				data = "actions";
			}
			let newRender;
			let statusTarget = actionList[data];
			newRender = render(
				actionCellDropdownTemplate, {
					list: renderActionCellList(statusTarget, data, row),
					index: meta.row
				}
			);
			return newRender;
		};

    function renderActionHeaderWrap() {
  	  let statusTarget = actionList['all'];
      if(!editPermission){
        statusTarget = []; //make empty
      }
	    let newRender;
	    let data = "";
	    let row = "";
	    newRender = render(
	      actionHeaderDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row)
	      }
	    );
	    return newRender;
    };

   function renderActionCellList(list,data,row) {
	    let renderedList = _(list).map((orderType)=>{
	      return render(
	        actionCellDropdownItemTemplate, neededActions(data, row, orderType)
	      )
   		 });
	    return renderedList.join('');
    };

    function neededActions(data, row, orderType){
			var action = {};
      if(orderType.title === 'Activate/Deactivate'){
        if(row.status === "Active"){
					action = {
						icon: 'toggle-off',
						title: 'Deactivate',
						cls: "deactivate-order-type",
						disabled: callBusinessLogicToDisableAction(data, row, orderType.title)
					};
        }else{
					action = {
						icon: 'toggle-on',
						title: 'Activate',
						cls: "activate-order-type",
						disabled: callBusinessLogicToDisableAction(data, row, orderType.title)
					};
        }
      }else if(orderType.title === 'Activate Selected Order Types'){
        action = {
          icon: orderType.icon,
          title: orderType.title,
          cls: orderType.cls,
          disabled: checkDisableForGivenAction(data, row, orderType.title)
        };
      }else if(orderType.title === 'Deactivate Selected Order Types'){
        action = {
          icon: orderType.icon,
          title: orderType.title,
          cls: orderType.cls,
          disabled: checkDisableForGivenAction(data, row, orderType.title)
        };
      }else{
        action = {
          icon: orderType.icon,
          title: orderType.title,
          cls: orderType.cls,
          disabled: orderType.disabled
        };
      }
      return action;
    };

	function checkDisableForGivenAction(data, row, actionName) {
    let isTrue = false;
    _(selectedRows).map((orderType)=>{
      if(callBusinessLogicToDisableAction(orderType.data.status, orderType.data, actionName)){
    	  if (!isTrue){
      		isTrue = true;
      	}
      }
    });
    return isTrue;
	};

	function callBusinessLogicToDisableAction(data, row, actionName) {
		if (editPermission && isPresent(data)) {
			if(row.retailerId == "0" || row.code == "B2B" || row.code == "B2C"){
				return true;
			}
			if(actionName === "Activate Selected Order Types"){
				if(data === "Active") {
					return true;
				}else{
					return false;
				}
			}
			else if(actionName === "Deactivate Selected Order Types"){
				if (data === "Inactive") {
					return true
				}else{
					return false;
				}
			}
		}
	}


	function filterSuccessFun(data){
		let orderTypes = data.content;
		let page = data.page;
		orderTypeLookup.setNewData(orderTypes);
		orderTypeLookup.setPaginationData(page)
		pushFilterSessionCacheState();
		orderTypeLookup.hideLoadingOverlay();
		setExportData(orderTypeLookup.generateData());
	}

	function errorFun(data){
   	    orderTypeLookup.hideLoadingOverlay();
	}

	function savedViewSuccess(data){
	    let orderTypes = data.orderTypeLookupJSON.content;
	    let page = data.orderTypeLookupJSON.page;
	    orderTypeLookup.setNewData(orderTypes);
	    orderTypeLookup.setPaginationData(page);
	    orderTypeLookup.setNewSavedViewData(data.savedView, "newSavedView");
	  	pushFilterSessionCacheState();
	    orderTypeLookup.hideLoadingOverlay();
	    setExportData(orderTypeLookup.generateData());
	}

	function savedEditViewSuccess(data){
	    let orderTypes = data.orderTypeLookupJSON.content;
	    let page = data.orderTypeLookupJSON.page;
	    orderTypeLookup.setNewData(orderTypes);
	    orderTypeLookup.setPaginationData(page);
	    orderTypeLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	  	pushFilterSessionCacheState();
	    orderTypeLookup.hideLoadingOverlay();
	    setExportData(orderTypeLookup.generateData());
	}


	function delteViewScussFun(data){
	    let orderTypes = data.orderTypeLookupJSON.content;
	    let page = data.orderTypeLookupJSON.page;
		orderTypeLookup.removeSavedView(data.target);
		orderTypeLookup.setNewData(orderTypes);
	    orderTypeLookup.setPaginationData(page);
		orderTypeLookup.hideLoadingOverlay();
	    setExportData(orderTypeLookup.generateData());
	}

    $('body').on('click', '.edit-order-type', function(e){
			  e.preventDefault(); 
        let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
				let parent = $(".dropdown-parent-" + pIndex).parents('tr');
        let row = table.row(parent);
        let cotId =row.data().customOrderTypeId;
        window.location.href = orderTypeEditURL+"&cotId=" + cotId;
		});
		
	$('body').on('click', ".duplicate-order-type", function (e) {
		
		e.preventDefault();
		let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
		let row = table.row(parent);
		let cotId = row.data().customOrderTypeId;
		window.location.href = orderTypeEditURL + "&cotId=" + cotId + "&isDup=true";
	});

	$('body').on( 'click', '.deactivate-order-type', function (e) {
		e.preventDefault();
		if(shallAllowClick(this)){
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
		let row = table.row(parent);
			var submitModalFlow = new SubmitModalFlow({
				confirmModalTitle: 'Deactivate Order Type',
				confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this order type will no longer be available when creating orders. It can be activated at any time.</div>',
				confirmModalBtnText: 'Deactivate',
				onConfirmClick: function () {
					submitModalFlow.showLoadingModal();
					deactivateOrderType(row, row.data());
					function deactivateOrderType(row, orderType) {
						$.ajax({
							url: updateOrderTypeStatusUrl,
							type: 'POST',
							dataType: 'JSON',
							data: {
								[`${portletNamespace}customOrderTypeId`]: orderType.customOrderTypeId
							},
							success: function (data) {
								if (data.responseStatus === "success") {
									var d = row.data();
									d.status = "Inactive";
									row.data(d).draw();
									submitModalFlow.showSuccessModal();
									setTimeout(function () {
										submitModalFlow.hideAllModals();
									}, window.constants.SUCCESS_MODAL_TIMEOUT);
								} else {
									submitModalFlow.showFailureModal();
								}
							},
							error: function (data) {
								submitModalFlow.hideAllModals();
							}
						});
					};
				}
			});
			submitModalFlow.init();
			submitModalFlow.showConfirmModal();
		}

  });

	$('body').on( 'click', '.activate-order-type', function (e) {
    e.preventDefault();
		if(shallAllowClick(this)){
			let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
			// Get the row based on the parent...
			let parent = $(".dropdown-parent-" + pIndex).parents('tr');
			// Get the row data
			let row = table.row(parent);
			var submitModalFlow = new SubmitModalFlow({
				confirmModalTitle: 'Activate Order Type',
				confirmModalBody: '<div class="q-pad-all-xl">Once activated, this order type will continue to be available when creating orders. It can be deactivated at any time</div>',
				confirmModalBtnText: 'Activate',
				onConfirmClick: function () {
					submitModalFlow.showLoadingModal();
					activateOrderType(row, row.data());
					function activateOrderType(row, orderType) {
						$.ajax({
							url: updateOrderTypeStatusUrl,
							type: 'POST',
							dataType: 'JSON',
							data: {
								[`${portletNamespace}customOrderTypeId`]: orderType.customOrderTypeId
							},
							success: function (data) {
								if (data.responseStatus === "success") {
									let d = row.data();
									d.status = "Active";
									row.data(d).draw();
									submitModalFlow.showSuccessModal();
									setTimeout(function () {
										submitModalFlow.hideAllModals();
									}, SUCCESS_MODAL_TIMEOUT);
								}
							},
							error: function (data) {
								submitModalFlow.hideAllModals();
							}
						});
					};
				}
			});
			submitModalFlow.init();
			submitModalFlow.showConfirmModal();
		}
  });

$('body').on('click', '.bulk-activate-order-types', function(e) {
		e.preventDefault();
		if(shallAllowClick(this)){
      var submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: 'Activate Order Types',
        confirmModalBody: '<div class="q-pad-all-xl">Once activated, this order type will continue to be available when creating orders. It can be deactivated at any time.</div>',
        confirmModalBtnText: 'Activate',
        onConfirmClick: function() {
          submitModalFlow.showLoadingModal();
          bulkActivateOrderTypes();
          function bulkActivateOrderTypes() {
            $.ajax({
              url: bulkActivateOrderTypesUrl,
              type: 'POST',
              dataType: 'JSON',
              data: {
                [`${portletNamespace}orderTypeIds`]: getAllSelectedOrderTypeIds()
              },
              success: function(data){
                if(data.response == "success") {
                  _(selectedRows).map((orderType)=>{
       	      	    let currentRow =  table.row(orderType.rowIndex)
       	     	      var d = currentRow.data();
                      d.status = "Active";
                      currentRow.data(d).draw();
       	    	    });
                  orderTypeLookup.uncheckAllSelected();
                  submitModalFlow.showSuccessModal();
                  setTimeout(function() {
                    submitModalFlow.hideAllModals();
                  }, window.constants.SUCCESS_MODAL_TIMEOUT);
                }else{
                  submitModalFlow.showFailureModal();
                }
              },
              error: function(data){
                submitModalFlow.hideAllModals();
              }
            });
          }
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
		}
	});

$('body').on('click', '.bulk-deactivate-order-types', function(e) {
		e.preventDefault();
		if(shallAllowClick(this)){
      var submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: 'Deactivate Order Types',
        confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this order type will no longer be available when creating orders. It can be activated at any time.</div>',
        confirmModalBtnText: 'Deactivate',
        onConfirmClick: function() {
          submitModalFlow.showLoadingModal();
          bulkActivateOrderTypes();
          function bulkActivateOrderTypes() {
            $.ajax({
              url: bulkDeactivateOrderTypesUrl,
              type: 'POST',
              dataType: 'JSON',
              data: {
                [`${portletNamespace}orderTypeIds`]: getAllSelectedOrderTypeIds()
              },
              success: function(data){
                if(data.response == "success") {
                  _(selectedRows).map((orderType)=>{
       	      	    let currentRow =  table.row(orderType.rowIndex)
       	     	      var d = currentRow.data();
                      d.status = "Inactive";
                      currentRow.data(d).draw();
       	    	    });
                  orderTypeLookup.uncheckAllSelected();
                  submitModalFlow.showSuccessModal();
                  setTimeout(function() {
                    submitModalFlow.hideAllModals();
                  }, window.constants.SUCCESS_MODAL_TIMEOUT);
                }else{
                  submitModalFlow.showFailureModal();
                }
              },
              error: function(data){
                submitModalFlow.hideAllModals();
              }
            });
          }
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
		}
	});

	function getAllSelectedOrderTypeIds(){
		var orderTypeIds = new Array();
		_(selectedRows).map((orderType)=>{
			orderTypeIds.push(orderType.data.customOrderTypeId);
	 	});
		return orderTypeIds;
	}


	// Export component integration.
	function initExport() {
		let exportObj = {
			title: mainEl.data("export-popup-title"),
			exportAttemptTextPart1Lang: mainEl.data("export-attempt-text-part1"),
			exportAttemptTextPart2Lang: mainEl.data("export-attempt-text-part2"),
			exportMaxLimitLang: mainEl.data("export-max-row-limit")
		};
		exportModal.init(exportObj);
		exportModal.bindExportEvent();
	}

	function setExportData(currentData) {
		exportModal.buildExportBasicURL(generateExportUrl, currentData);
		exportModal.setExportCount(currentData.totalElements);
	}
	initExport();
	setExportData(orderTypeLookup.generateData());
	handleCustomDropdownEvents();
	//Export Component 

});


// WEBPACK FOOTER //
// ./src/pages/orderType/lookup.js